import { Stack, Typography } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

interface DispositionsFormSplitScreenRightPanelProps {
  IconElement: React.ReactNode;
  title: React.ReactNode;
  subtitle: string;
  dataTestId?: string;
}

/**
 * Panel displayed on the right side of the split screen modal with an icon,
 * title, and subtitle, centered in the middle of the panel.
 *
 * @param IconElement
 * @param title
 * @param subtitle
 * @param dataTestId
 * @constructor
 */
export function DispositionsFormSplitScreenRightPanel({
  IconElement,
  title,
  subtitle,
  dataTestId,
}: DispositionsFormSplitScreenRightPanelProps) {
  return (
    <Stack
      data-testid={dataTestId}
      spacing={1}
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        alignItems: 'center',
        justifyContent: 'center',
        background: COLORS.PRIMITIVES.WHITE,
      }}
    >
      {IconElement}
      <Typography variant="title-l" maxWidth={400} textAlign="center">
        {title}
      </Typography>
      <Typography
        variant="body-s"
        maxWidth={400}
        textAlign="center"
        color={COLORS.GRAY['500']}
      >
        {subtitle}
      </Typography>
    </Stack>
  );
}
